import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/router/permission'
/*js*/
import ElementUI from 'element-ui'
import Avue from '@smallwei/avue'
import AvueUeditor from 'avue-plugin-ueditor'
import utils from "@/utils"
import axios from "axios"
import components from '@/components/index'
/*css*/
// 初始化样式
import 'normalize.css/normalize.css'
//element-ui css
import 'element-ui/lib/theme-chalk/index.css'
// avue css
import '@smallwei/avue/lib/index.css'
/*use*/
// element-ui
Vue.use(ElementUI)
// utils
Vue.use(utils)
//注册组件
Vue.use(components)
//允许生产环境下打印日志
Vue.config.devtools=true
// avue
Vue.use(Avue,{
  axios: axios,
  qiniu:{
    AK: 'Us0_Dt2m8M-tymwTCrzBHL9ImxzPK4FYfCMyfApX',//七牛云相关密钥
    SK: '3kJSTW_l1D0X169T7xzwNY1wcTRURrL-3ftIGumz',//七牛云相关密钥
    bucket:'https://upload-z1.qiniup.com',//存储地区
    scope: 'zhihuidapeng',//存储空间名称
    url: 'https://dapeng.quwen.xyz/',//外链的域名地址
  }
})
Vue.use(AvueUeditor)
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
